'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';
import globalStore from '../Global';

class AppStrategyStore {
  @observable strategyList = [];
  @observable currentStrategId = 0;

  @observable listPageTotal = 1;
  @observable currentPage = 1;

  @observable addStrategyModalStatus = false;

  @observable AppListinitialValue = [];
  @observable AppNameListinitialValue = [];
  @observable AppStartListinitialValue = [];
  @observable AppVersionListinitialValue = [];

  @observable AcrossVersions = false;
  @observable AcrossVersionsDate = '';

  @observable SyncModalStatus = false;
  @observable SyncModalData = {};

  @observable SyncAcrossVersionModal = false;
  @observable SyncAcrossVersionData = {};

  @observable AppProgressModalStatus = false;
  @observable AppProgressModalData = [];

  @action.bound
  resetObservable() {
    this.strategyList = [];
    this.currentStrategId = 0;

    this.listPageTotal = 1;
    this.currentPage = 1;

    this.addStrategyModalStatus = false;

    this.AppListinitialValue = [];
    this.AppNameListinitialValue = [];
    this.AppStartListinitialValue = [];
    this.AppVersionListinitialValue = [];

    this.AcrossVersions = false;
    this.AcrossVersionsDate = '';

    this.SyncModalStatus = false;
    this.SyncModalData = {};

    this.SyncAcrossVersionModal = false;
    this.SyncAcrossVersionData = {};

    this.AppProgressModalStatus = false;
    this.AppProgressModalData = [];
  }

  @action.bound
  loadAppStrategyList(page) {
    globalStore.loadingStatus = true;
    globalStore.loadingTip = '正在加载中...';
    let param = buildUrl({
      page_num: page,
      page_size: 10
    });
    fetch(`/api/app/strategy${param}`, { method: 'GET' }, json => {
      this.strategyList = json.content;
      this.listPageTotal = json.total;
      globalStore.loadingStatus = false;
      globalStore.loadingTip = '';
    });
  }

  @action.bound
  hideAddStrategyModal(form) {
    this.addStrategyModalStatus = false;
    form && form.resetFields();
    this.changeInitialData([]);
  }

  @action.bound
  showAddStrategyModal() {
    this.addStrategyModalStatus = true;
  }

  @action.bound
  hideAcrossVersionsModal() {
    this.AcrossVersions = false;
    this.loadAppStrategyList(this.currentPage);
  }

  @action.bound
  showAcrossVersionsModal() {
    this.AcrossVersions = true;
  }

  @action.bound
  hideAppProgressModal() {
    this.AppProgressModalStatus = false;
  }

  @action.bound
  showAppProgressModal() {
    this.AppProgressModalStatus = true;
  }

  @action.bound
  hideSyncModal() {
    this.SyncModalStatus = false;
  }

  @action.bound
  showSyncModal() {
    this.SyncModalStatus = true;
  }

  @action.bound
  changeInitialData(appList) {
    this.AppListinitialValue = [];
    this.AppNameListinitialValue = [];
    this.AppStartListinitialValue = [];
    this.AppVersionListinitialValue = [];
    appList.forEach((item, index) => {
      this.AppListinitialValue.push(index + 1);
      this.AppNameListinitialValue.push(item.id + '');
      this.AppStartListinitialValue.push(true);
      this.AppVersionListinitialValue.push(item['current_version']);
    });
  }

  @action.bound
  showSyncAcrossVersionModal(id, isCheck, time) {
    this.SyncAcrossVersionModal = true;
    this.SyncAcrossVersionData = { id: id, isCheck: isCheck, time: time };
  }

  @action.bound
  hideSyncAcrossVersionModal(id, isCheck, time) {
    this.SyncAcrossVersionModal = false;
    this.hideSyncModal();
    this.SyncAcrossVersionData = {};
  }

  @action.bound
  AddAppStrategy(data) {
    return fetch(
      '/api/app/strategy',
      {
        method: 'POST',
        body: data
      },
      json => json
    );
  }

  @action.bound
  postStrategyProgress(id, isCheck, time) {
    let param = buildUrl({ id: id, check_version: isCheck, plan_date: time });
    fetch(`/api/app/strategy/progress${param}`, { method: 'POST' }, json => {
      this.currentPage = 1;
      if (json.code === 1406) {
        this.showSyncAcrossVersionModal(id, isCheck, time);
      } else {
        window.location.reload();
        this.hideSyncModal();
        this.hideSyncAcrossVersionModal();
      }
    });
  }

  @action.bound
  cancelStrategy(id) {
    fetch(`/api/app/strategy/cancel?id=${id}`, { method: 'POST' }, json => {
      this.loadAppStrategyList(this.currentPage);
    });
  }

  @action.bound
  deleteAppStrategy(id) {
    fetch(`/api/app/strategy?id=${id}`, { method: 'DELETE' }, json => {
      this.loadAppStrategyList(this.currentPage);
    });
  }

  @action.bound
  loadStrategyProgress(id) {
    fetch(`/api/app/strategy/progress?id=${id}`, { method: 'GET' }, json => {
      this.AppProgressModalData = [...json].map((item, index) => {
        item.key = index + 1;
        return item;
      });
      this.showAppProgressModal();
    });
  }

  @action.bound
  changePage(page) {
    this.currentPage = page;
    this.loadAppStrategyList(page);
  }
}
export default new AppStrategyStore();



// WEBPACK FOOTER //
// ./src/store/AppStrategy/AppStrategy.js